module.exports = __webpack_public_path__ + "static/img/er.fea32ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/er.jpg
// module id = Iq6C
// module chunks = 21